<template>

  <table-layout class="  rounded rounded-9" title="سفارش های من" :showSearch="false">

    <template #buttons></template>
    <template #table>
      <table-items :items="items" :restoreState="false"/>
      <div class="row text-center pt-3">
        <div class="mt-3 ml-auto mr-auto color">
          <pagination :meta="paginationMeta" :on-change-page="changePage"/>
        </div>
      </div>
    </template>
  </table-layout>
</template>
<script>
import {mapGetters} from "vuex";
import TableLayout from "../../components/dashboard/TableLayout";
import Pagination from "../../components/dashboard/Pagination";
import tableItems from "../../components/dashboard/orders/tableItems.vue";

export default {
  name: "orders",
  components: {TableLayout, Pagination, tableItems},
  mounted() {
    this.$store.dispatch("ShoppingCart/getOrders");
  },
  computed: {
    ...mapGetters({
      items: "ShoppingCart/getOrders",
      paginationMeta: "ShoppingCart/getPaginationMeta",
    }),
  },
  methods: {
    changePage(page) {
      console.log("page", page);
      this.$store.dispatch("ShoppingCart/getOrders", page);
    },
  },
};
</script>
<style scoped>
.order-background{
  background: #f3f3f3;
}
</style>